/**************************************************
 * Nombre:       Indicador
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {FiberManualRecord} from "@mui/icons-material";

const Indicador = ({texto, textoColor = '#000', color = '#4AFF83'}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Typography sx={{
                fontSize: 12,
                fontWeight: 400,
                backgroundColor: color,
                color: textoColor,
                pl: 1.5,
                pr: 1,
                pb: 0.3,
                borderRadius: 6,
                pt: 0.15,
            }}>{texto}
                <FiberManualRecord sx={{fill: '#000', width: 14, height: 14, mt: 0.3, mb: -0.3, pl: 0.5}}/>
            </Typography>

        </Grid>
    )

}
export default Indicador